import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

/**
 * The entity icon for an opening — a briefcase.
 *
 * Filled rather than stroked, and `fill` is left to inherit `currentColor`, so
 * the colour is the caller's decision (the design's own value is gray500) and
 * the same icon can sit on a dark or a light surface without a second copy.
 *
 * Paired with `OfferIcon`; the two are only meaningful together, as the pair
 * that distinguishes what a rule gates. Keep them visually consistent.
 *
 * `fillRule="evenodd"` is load-bearing, not decoration — see the note on
 * `OfferIcon`. Here it is the handle's cut-out and the clasp that depend on it.
 */
export const OpeningIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M10 2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v2.382l1.447.723.005.003.027.013.12.056c.163.077.323.145.486.212.429.177 1.056.416 1.834.655C7.481 13.524 9.63 14 12 14c2.372 0 4.52-.475 6.08-.956.78-.24 1.406-.478 1.835-.655a14 14 0 0 0 .606-.268l.027-.013.005-.002L22 11.381V9a3 3 0 0 0-3-3h-2V5a3 3 0 0 0-3-3zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zm6.447 7.894.553-.276V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5.382l.553.276.002.001.004.002.013.006.041.02.151.07c.13.06.318.144.557.242.478.198 1.163.46 2.01.72C7.019 15.476 9.37 16 12 16c2.628 0 4.98-.525 6.67-1.044a23 23 0 0 0 2.01-.72 16 16 0 0 0 .707-.312l.041-.02.013-.006.004-.002zM12 10a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z"
      fillRule="evenodd"
    />
  </SvgIcon>
);
